
import buttonStyles from "./round-button.module.css";


export default function JumpCode () {



    return (
        <a href={`#Coding-Projects`}>
            <div className={`${buttonStyles.toggleButton} ${buttonStyles.jumpButton}`}>
                < img src="./images/code-icon.png" className={buttonStyles.toggleImage} alt="Jump to Coding Projects button" />
            </div>
        </a>
    )
}